module.exports = __webpack_public_path__ + "img/company_info.48a6204d.png";